import { render, staticRenderFns } from "./ConsentIcon.vue?vue&type=template&id=0d85dae8&scoped=true&"
import script from "./ConsentIcon.vue?vue&type=script&lang=js&"
export * from "./ConsentIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d85dae8",
  null
  
)

export default component.exports